<template>
    <v-card class="mb-5 mt-5 media-card" width="250px">
        <v-img height="150px" width="250px" class="v-media"
               :src="media.thumbnail_url !== null ? media.thumbnail_url : media.url"
               @click="showMedia()">
            <div class="media-logo"
                 v-if="media.source !== undefined && media.source !== null && media.source.type !== 'APIDAE'">
                <img :src="'/images/logo-' + media.source.type + '.jpg'" style="width: 30px;">
            </div>
        </v-img>

        <div class="clear-toolbar">
            <v-btn fab x-small>
                <v-icon size="21px" @click="deleteMedia()">clear</v-icon>
            </v-btn>
        </div>

        <div class="quality-icon-photo">
            <v-tooltip bottom v-if="media.width < 1920 && media.height < 1920 &&
                            media.width !== null && media.height !== null">
                <template v-slot:activator="{ on }">
                    <v-icon large v-on="on" color="warning">info</v-icon>
                </template>
                <div>Cette photo semble être en faible définition.
                    <br>Nous vous recommandons de sélectionner des photos de plus grand format.
                </div>
            </v-tooltip>
        </div>

        <v-card-text>
            <label>Titre</label>
            <v-text-field v-model="media.name" outlined hide-details
                          class="mb-3">
            </v-text-field>
            <label :class="{'required': field.required}">Copyright</label>
            <v-text-field
              :class="{'input-error': submitted && (media.copyright === null || media.copyright === '')}"
              hide-details v-model="media.copyright" outlined>
            </v-text-field>

            <div class="w-100 text-center mt-3" v-if="!disabled && index === 0">
                <v-btn class="switch-btn default-button text-none"
                       v-if="provider.medias.length > 1"
                       :style="'background-color:' + primaryColor + '!important'"
                       @click="swapMedia()">
                    Changer mon image <br>principale
                </v-btn>
            </div>
        </v-card-text>

        <swap-media-modal v-if="switchMediaDialog"></swap-media-modal>

        <confirm ref="confirm" :hide-next="true"></confirm>
    </v-card>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import Confirm from "../../../../tools/Confirm.vue"
import SwapMediaModal from "../../modals/SwapMediaModal.vue"

export default {
    name: "MediaCard",
    components: {SwapMediaModal, Confirm},
    props: ['media', 'field', 'index'],
    methods: {
        ...mapMutations('web_form', ['removeMedia', 'setMediaFullScreenDialog', 'setSwitchMediaDialog', 'setCurrentMedia']),
        showMedia() {
            this.setCurrentMedia(this.media)
            this.setMediaFullScreenDialog(true)
        },
        swapMedia() {
            this.setSwitchMediaDialog(true)
        },
        deleteMedia() {
            if (!this.hideNextModal) {
                this.$refs.confirm.open('Attention',
                  'Êtes-vous sûr de vouloir supprimer cette photo ?',
                  { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.removeMedia(this.index)
                    }
                })
            } else {
                this.removeMedia(this.index)
            }
        },
    },
    computed: {
        ...mapState("web_form", ['submitted', 'disabled', 'mediaFullScreenDialog', 'switchMediaDialog', "provider", 'hideNextModal']),
        ...mapState("webFormStyle", ["fieldsColor", 'primaryColor', 'fontFamily']),
    }
}
</script>
